<template>
  <div class="tag-filter-overview">
    <ul class="button-group list-unstyled">
      <li
        v-for="filter in filters"
        :key="filter.name"
      >
        <TogglePill
          :label="filter.name"
          :active="isActiveFilter(filter)"
          @toggle="onFilterToggle(filter, $event)"
        />
      </li>
    </ul>
    <div class="component-spacing-top-s">
      <slot
        v-if="isLoading"
        name="overview-loading"
      />
      <slot
        v-else
        name="overview-result"
        :should-render-item="shouldRenderItem"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import TogglePill from '@/components/filter/TogglePill.vue';
import { getUrlSearchParams, updateUrlSearchParams } from '@/utils/url';
import { simulateLoadingTime } from '@/utils/loading';

const props = defineProps({
  filters: { type: Array, default: () => [] },
  activeFilterUrlQueryParam: { type: String, required: true },
});

const activeFilter = ref(getPreselectedFilterFromUrl());
const isLoading = ref(false);

watchEffect(() => {
  updateUrlWithActiveFilter();
});

function getPreselectedFilterFromUrl() {
  const urlSearchParams = getUrlSearchParams();
  const preselectedFilterName = urlSearchParams.get(props.activeFilterUrlQueryParam);
  if (!preselectedFilterName) {
    return null;
  }

  // find filter by name (case insensitive)
  const preselectedFilter = props.filters.find((filter) => filter.name?.toLowerCase() === preselectedFilterName.toLowerCase());
  return preselectedFilter ? preselectedFilter.name : null;
}

function updateUrlWithActiveFilter() {
  if (activeFilter.value) {
    updateUrlSearchParams({ [props.activeFilterUrlQueryParam]: activeFilter.value.toLowerCase() });
  }
}

async function onFilterToggle(filter, active) {
  activeFilter.value = active ? filter.name : null;
  isLoading.value = true;
  await simulateLoadingTime(500);
  isLoading.value = false;
}

function shouldRenderItem(tag) {
  if (!tag || activeFilter.value === null) {
    return true;
  }
  return tag === activeFilter.value;
}

function isActiveFilter(filter) {
  return activeFilter.value === filter.name;
}
</script>
